/* ---------------------------------------------------------------------
   Mamavea - Bundle & Save box (Montleigh style)
   Loaded from snippets/css-variables.liquid

   The Bundle & Save box on the product page is a Custom Liquid block
   inside templates/product.json. It ships three stacked rows
   (Buy 2 / Buy 3 / Buy 4) with its own inline <style>.

   This script turns that box into the approved layout:

       +-----------------------------------+
       |          BUNDLE & SAVE            |
       |  [ 2 ITEMS ]      [ 3 ITEMS ]     |
       |  [ 10% OFF ]      [ 15% OFF ]     |
       |  [ 4 ITEMS ]      [ 5 ITEMS ]     |
       |  [ 20% OFF ]      [ 25% OFF ]     |
       |  Discount applied automatically   |
       |            at checkout.           |
       +-----------------------------------+

   It relabels the tiers ("Buy 2 items" -> "2 items"), appends the new
   5 items / 25% off tier, adds the footnote, and injects the grid CSS.
   Idempotent, and re-runs on Shopify section reloads so it survives
   theme-editor edits.

   Typography follows Theme settings > Typography, via the same CSS
   variables the rest of the store uses (see mamavea-fonts.css):
     title            -> --typeHeaderPrimary (Montserrat)
     tiers + footnote -> --typeBasePrimary   (Nunito Sans)
   The bold tier weight is 600, not 700: snippets/font-face.liquid loads
   the body font at 400/600 only, so 700 would be a faked bold.

   TO MAKE THIS PERMANENT (and delete this file): open the theme editor,
   go to the product template, select the "Bundle & Save" custom block,
   and paste the markup + CSS below straight into its HTML.
--------------------------------------------------------------------- */

(function () {
  'use strict';

  var TIERS = [
    { qty: '2 items', pct: '10% off' },
    { qty: '3 items', pct: '15% off' },
    { qty: '4 items', pct: '20% off' },
    { qty: '5 items', pct: '25% off' }
  ];
  var NOTE_TEXT = 'Discount applied automatically at checkout.';
  var STYLE_ID = 'mamavea-bundle-style';

  var HEADER_FONT = 'var(--typeHeaderPrimary, Montserrat), var(--typeHeaderFallback, sans-serif)';
  var BASE_FONT = 'var(--typeBasePrimary, \'Nunito Sans\'), var(--typeBaseFallback, sans-serif)';

  /* The block's own <style> lives in the body and uses !important, so
     every selector here is doubled to outrank it regardless of order. */
  var CSS = [
    '.bundle-save.bundle-save {',
    '  display: grid !important;',
    '  grid-template-columns: repeat(2, 1fr) !important;',
    '  gap: 10px !important;',
    '  width: 100% !important;',
    '  margin: 0 0 18px !important;',
    '  padding: 18px 16px 14px !important;',
    '  border: 1px solid #e3e3e3 !important;',
    '  border-radius: 6px !important;',
    '  background: #f7f7f7 !important;',
    '  overflow: visible !important;',
    '  box-sizing: border-box !important;',
    '}',
    '.bundle-save .bundle-save-title.bundle-save-title {',
    '  grid-column: 1 / -1 !important;',
    '  margin: 0 0 4px !important;',
    '  padding: 0 !important;',
    '  border: 0 !important;',
    '  background: transparent !important;',
    '  font-family: ' + HEADER_FONT + ' !important;',
    '  font-size: 14px !important;',
    '  font-weight: 700 !important;',
    '  letter-spacing: 0.1em !important;',
    '  text-transform: uppercase !important;',
    '  text-align: center !important;',
    '  color: #111 !important;',
    '}',
    '.bundle-save .bundle-save-row.bundle-save-row {',
    '  display: flex !important;',
    '  flex-direction: column !important;',
    '  align-items: center !important;',
    '  justify-content: center !important;',
    '  gap: 4px !important;',
    '  padding: 14px 8px !important;',
    '  background: #fff !important;',
    '  border: 1px solid #e3e3e3 !important;',
    '  border-radius: 4px !important;',
    '  text-align: center !important;',
    '}',
    '.bundle-save .bundle-save-qty.bundle-save-qty {',
    '  font-family: ' + BASE_FONT + ' !important;',
    '  font-size: 13px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 1.2 !important;',
    '  letter-spacing: 0.06em !important;',
    '  text-transform: uppercase !important;',
    '  color: #333 !important;',
    '}',
    '.bundle-save .bundle-save-pct.bundle-save-pct {',
    '  font-family: ' + BASE_FONT + ' !important;',
    '  font-size: 15px !important;',
    '  font-weight: 600 !important;',
    '  line-height: 1.2 !important;',
    '  letter-spacing: 0.04em !important;',
    '  text-transform: uppercase !important;',
    '  color: #111 !important;',
    '}',
    '.bundle-save .bundle-save-note.bundle-save-note {',
    '  grid-column: 1 / -1 !important;',
    '  margin: 4px 0 0 !important;',
    '  padding: 0 !important;',
    '  font-family: ' + BASE_FONT + ' !important;',
    '  font-size: 12px !important;',
    '  font-weight: 400 !important;',
    '  line-height: 1.4 !important;',
    '  color: #666 !important;',
    '  text-align: center !important;',
    '}',
    '@media screen and (max-width: 749px) {',
    '  .bundle-save.bundle-save { padding: 16px 12px 12px !important; gap: 8px !important; }',
    '  .bundle-save .bundle-save-row.bundle-save-row { padding: 12px 6px !important; }',
    '  .bundle-save .bundle-save-qty.bundle-save-qty { font-size: 12px !important; }',
    '  .bundle-save .bundle-save-pct.bundle-save-pct { font-size: 14px !important; }',
    '}'
  ].join('\n');

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    (document.head || document.documentElement).appendChild(style);
  }

  function makeTile(tier) {
    var row = document.createElement('div');
    row.className = 'bundle-save-row';

    var qty = document.createElement('span');
    qty.className = 'bundle-save-qty';
    qty.textContent = tier.qty;

    var pct = document.createElement('span');
    pct.className = 'bundle-save-pct';
    pct.textContent = tier.pct;

    row.appendChild(qty);
    row.appendChild(pct);
    return row;
  }

  function upgradeBox(box) {
    var rows = box.querySelectorAll('.bundle-save-row');
    if (!rows.length) return;

    /* 1. Relabel the tiers we already have: "Buy 2 items" -> "2 items". */
    Array.prototype.forEach.call(rows, function (row, i) {
      var tier = TIERS[i];
      if (!tier) return;
      var qty = row.querySelector('.bundle-save-qty');
      var pct = row.querySelector('.bundle-save-pct');
      if (qty) qty.textContent = tier.qty;
      if (pct) pct.textContent = tier.pct;
    });

    /* 2. Append any tiers the block is missing (currently the 5-item one). */
    var lastRow = rows[rows.length - 1];
    for (var i = rows.length; i < TIERS.length; i++) {
      var tile = makeTile(TIERS[i]);
      lastRow.parentNode.insertBefore(tile, lastRow.nextSibling);
      lastRow = tile;
    }

    /* 3. Append the footnote if it isn't already there. */
    if (!box.querySelector('.bundle-save-note')) {
      var note = document.createElement('div');
      note.className = 'bundle-save-note';
      note.textContent = NOTE_TEXT;
      box.appendChild(note);
    }
  }

  function run() {
    injectStyle();
    var boxes = document.querySelectorAll('.bundle-save');
    Array.prototype.forEach.call(boxes, upgradeBox);
  }

  injectStyle();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 600);
})();
